import SeoPageLayout from "@/components/SeoPageLayout";

const ProwadzenieImprezFirmowych = () => (
  <SeoPageLayout title="Prowadzenie imprez firmowych - profesjonalny konferansjer">
    <p>
      Profesjonalne prowadzenie imprezy firmowej to klucz do sukcesu każdego wydarzenia. Nasz konferansjer z doświadczeniem kabaretowym łączy elegancję z humorem, prowadząc wieczór płynnie i zapewniając doskonałą atmosferę.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Co wyróżnia nasze prowadzenie?</h2>
    <p>
      Nasz prowadzący to nie zwykły konferansjer - to doświadczony artysta kabaretowy, który potrafi reagować na sytuację, improwizować i utrzymywać energię wieczoru na najwyższym poziomie. Łączy profesjonalizm z naturalnym poczuciem humoru.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Rodzaje imprez, które prowadzimy</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Gale firmowe - eleganckie prowadzenie z klasą</li>
      <li>Bankiety i kolacje - lekki humor między daniami</li>
      <li>Imprezy integracyjne - energetyczne prowadzenie z zabawami</li>
      <li>Konferencje - profesjonalny konferansjer z humorem</li>
      <li>Wigilie firmowe - ciepłe, świąteczne prowadzenie wieczoru</li>
      <li>Pikniki firmowe - dynamiczne prowadzenie na świeżym powietrzu</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Pełna obsługa wieczoru</h2>
    <p>
      Oferujemy kompleksową obsługę - od planowania harmonogramu, przez koordynację z DJ-em i obsługą techniczną, po prowadzenie konkursów i zabaw. Nasz konferansjer dba o to, by program przebiegał płynnie, a goście świetnie się bawili.
    </p>
  </SeoPageLayout>
);

export default ProwadzenieImprezFirmowych;
